import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-general-settings-select-image',
  templateUrl: './general-settings-select-image.component.html',
  styleUrls: ['./general-settings-select-image.component.css']
})
export class GeneralSettingsSelectImageComponent implements OnInit {

  @Input() userSettings;
  @Input() img:string;


  @Output() selectBg = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  openPatchBg() {
    this.selectBg.emit()
  }

}
